import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AuthSync from './components/AuthSync';
import ProtectedRoute from './components/ProtectedRoute';

// Route-level code splitting — the audit flagged a single 501 KB bundle;
// every route is now its own chunk, loaded on demand.
const Home = lazy(() => import('./pages/Home'));
const MovieDetail = lazy(() => import('./pages/MovieDetail'));
const Cinemas = lazy(() => import('./pages/Cinemas'));
const CinemaDetail = lazy(() => import('./pages/CinemaDetail'));
const Search = lazy(() => import('./pages/Search'));
const SignIn = lazy(() => import('./pages/SignIn'));
const SignUp = lazy(() => import('./pages/SignUp'));
const Account = lazy(() => import('./pages/Account'));
const Privacy = lazy(() => import('./pages/Privacy'));
const NotFound = lazy(() => import('./pages/NotFound'));

function RouteFallback() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-16 text-center text-cinema-gray" role="status">
      Loading…
    </div>
  );
}

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-cinema-black text-cinema-white">
      <AuthSync />
      <Navbar />
      <main className="flex-1 w-full">
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/movie/:id" element={<MovieDetail />} />
            <Route path="/cinemas" element={<Cinemas />} />
            <Route path="/cinema/:id" element={<CinemaDetail />} />
            <Route path="/search" element={<Search />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/account" element={<Account />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
